import React, { memo } from 'react'
import { IconButton } from '@mui/material'

import { FacebookIcon } from '../../assets/icons/social-icons'

const Facebook = ({ disabled, onClick }) => {
  return (
    <IconButton color='inherit' onClick={onClick} disabled={disabled}>
      <FacebookIcon width={22} />
    </IconButton>
  )
}

export default memo(Facebook)
